/* eslint-disable no-useless-escape */
export const appVersion = 'public'

const linkDataset = {
    api: 'https://services2.arcgis.com/qvkbeam7Wirps6zC/arcgis/rest/services/lvt_public_20231025/FeatureServer',
    parcelParentField: 'parent',
    parcelField: 'pnum',
    outFields: ['pnum', 'parent', 'bill_tv', 'tv_land', 'display_class', 'bill', 'final_lvt_bill_c', 'post_nez_bill_c', 'final_lvt_bill_nez_c', 'tax_classification', 'property_class'],
    fieldmap: [
        {
            field: "pnum",
            display: "Parcel Number(s)"
        },
        {
            field: "parent",
            display: "Parent Parcel"
        },
        {
            field: "bill_tv",
            display: "bill_tv"
        },
        {
            field: "tv_land",
            display: "tv_land"
        },
        {
            field: "display_class",
            display: "display_class"
        },
        {
            field: "bill",
            display: "bill"
        },
        {
            field: "final_lvt_bill_c",
            display: "final_lvt_bill_c"
        },
        {
            field: "post_nez_bill_c",
            display: "post_nez_bill_c"
        },
        {
            field: "final_lvt_bill_nez_c",
            display: "final_lvt_bill_nez_c"
        },
        {
            field: "tax_classification",
            display: "tax_classification"
        },
        {
            field: "property_class",
            display: "property_class"
        },
    ]
}


const searchTypes = [
    {
        value: 'byAddress', // First will be default
        label: 'Address',
        api: 'https://services2.arcgis.com/qvkbeam7Wirps6zC/ArcGIS/rest/services/Parcel_File_2023/FeatureServer/1',
        searchTemplate: "{address}",
        joins: {
                field: 'address',
                label: 'Address',
                instructions: 'Start by typing the address on your tax bill.'
        },
        retrieves: [
            {
                field: 'parcel_number',
                label: 'Parcel Number'
            },
            {
                field: 'address',
                label: 'Address'
            },
        ],
        link: {
            fromColumn: 'parcel_number',
            linkTo: linkDataset
        }

    },
    {
        value: 'byParcel',
        label: 'Parcel Number',
        api: 'https://services2.arcgis.com/qvkbeam7Wirps6zC/arcgis/rest/services/lvt_public_20231025/FeatureServer',
        searchTemplate: "{pnum}",
        joins: {
                field: 'pnum',
                label: 'Parcel Number',
                instructions: 'Start by typing a parcel number.'
        },
        retrieves: [
            {
                field: 'pnum',
                label: 'Parcel Number'
            },
            {
                field: 'parent',
                label: 'Parent Parcel Number'
            }
        ],
        link: {
            fromColumn: 'parent',
            linkTo: linkDataset
        }
    }
]

const searchText = {
    searchHeader: "Search By:" // searchTypes divs below
}

export const searchConfig = {
    searchTypes: searchTypes,
    searchText: searchText
}



